import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { isIOS } from 'react-device-detect'
import {
  List, Fab, Paper, Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PILLS_REMINDER_EDIT, PILLS_REMINDER_NEW, PILLS_REMINDERS } from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { Add, RemindersHistory } from 'icons'
// @ts-ignore — pillsReminders actions are still untyped JS
import { fetchPillsReminders, deletePillsReminder } from '@app/actions/pillsReminders/pillsReminders'
import TwoButtonsPopup from '@app/components/Common/TwoButtonsPopup/TwoButtonsPopup'
// @ts-ignore — ReminderCard is still untyped JSX
import ReminderCard from './ReminderCard/ReminderCard'
// @ts-ignore — RemindersTabs is still untyped JSX
import RemindersTabs from './RemindersTabs/RemindersTabs'
import useStyles from './PillsReminders.style'

const PillsReminders = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { classes } = useStyles()
  const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
  const { reminders } = useSelector((state: any) => state.pillsReminders)
  const [isDeletePopupOpen, setDeletePopupOpen] = useState<boolean>(false)
  const [currentReminderId, setCurrentReminderId] = useState<number | null>(null)

  useEffect(() => {
    if (isIOS && isWebView) {
      // eslint-disable-next-line no-alert
      prompt('showTopBar')
    }
    dispatch(fetchPillsReminders())
  }, [])

  const hideIOSToolbarInWebView = () => {
    if (isIOS && isWebView) {
    // eslint-disable-next-line no-alert
      prompt('hideTopBar')
    }
  }

  const onCreate = () => {
    hideIOSToolbarInWebView()
    navigate(PILLS_REMINDER_NEW)
  }

  const onEdit = (reminder: any) => {
    hideIOSToolbarInWebView()
    navigate(PILLS_REMINDER_EDIT.replace(':id', reminder.id))
  }

  const onDelete = (reminderId: number) => {
    setDeletePopupOpen(!isDeletePopupOpen)
    setCurrentReminderId(reminderId)
  }

  const onDeleteSubmit = () => {
    dispatch(deletePillsReminder(currentReminderId))
    setDeletePopupOpen(!isDeletePopupOpen)
  }

  const renderRemindersList = (remindersArray: any[]) => (
    <List className={classes.remindersList}>
      {remindersArray.map((reminder) => (
        <ReminderCard
          key={reminder.id}
          reminder={reminder}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </List>
  )

  const renderWithoutReminders = () => (
    <Wrapper className={classes.emptyReminders}>
      <RemindersHistory />
      <Typography className={classes.emptyText}>{I18n.t('my_reminders.no_reminders')}</Typography>
    </Wrapper>
  )

  return (
    <Paper className={classNames(isWebView && classes.webview, classes.root)}>
      <RemindersTabs active={PILLS_REMINDERS} />
      <Wrapper className={classNames(navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))}>
        {reminders.length ? renderRemindersList(reminders) : renderWithoutReminders()}
      </Wrapper>
      <Fab
        color="primary"
        aria-label="Add"
        className={classes.addButton}
        onClick={onCreate}
      >
        <Add />
      </Fab>
      <TwoButtonsPopup
        open={isDeletePopupOpen}
        withCloseIcon={false}
        title="titles.warning"
        text="confirmations.remove_reminder"
        firstButtonName="buttons.cancel"
        secondButtonName="buttons.okay"
        firstButtonOnClick={() => {
          setDeletePopupOpen(!isDeletePopupOpen)
        }}
        secondButtonOnClick={onDeleteSubmit}
      />
    </Paper>
  )
}

export default PillsReminders
